import { useTranslation } from 'react-i18next';

import { OppvarmingBruk, VannbarenVarme } from '../../types';

export const useCommonValidation = () => {
  const { t } = useTranslation();

  const validateVarmefordeling = (kaminValue?: VannbarenVarme) => {
    // Radiator and gulvvarme share the same validation. Requires at least one to be selected
    if (!kaminValue?.gulvvarme?.selected && !kaminValue?.radiator?.selected) {
      return t('form.oppvarming.common.kjel.fordelingssystem.error');
    }
    return true;
  };

  const validateOppvarmingBruk = (oppvarmingBruk?: OppvarmingBruk) => {
    if (
      !oppvarmingBruk?.romoppvarming &&
      !oppvarmingBruk?.tappevann &&
      !oppvarmingBruk?.ventilasjonVarmebatteri &&
      !oppvarmingBruk?.ukjent
    ) {
      return t('form.oppvarming.common.kjel.oppvarmingBruk.error');
    }
    return true;
  };

  return { validateOppvarmingBruk, validateVarmefordeling };
};
